<template>
    <fieldset class="col-md-12">
        <input type="hidden" name="clearingtype" v-model="localPaymentMethod">
        <input type="hidden" name="cardtype" v-model="cardtype">
        <input type="hidden" name="pseudocardpan" v-model="pseudocardpan">
        <input type="hidden" name="truncatedcardpan" v-model="truncatedcardpan">
        <input type="hidden" name="iban" v-model="iban">
        <input type="hidden" name="bic" v-model="bic">
        <input type="hidden" name="bankcountry" v-model="bankcountry">

        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="firstname">{{$t('strings.frontend.checkout.labels.firstname')}}</label>
                <input id="firstname" type="text" name="firstname" class="form-control"
                       required="required" v-model="firstname"
                />
            </div>
            <div class="form-group col-md-6">
                <label for="lastname">{{$t('strings.frontend.checkout.labels.lastname')}}</label>
                <input id="lastname" type="text" name="lastname" class="form-control"
                       required="required" v-model="lastname"
                />
            </div>
        </div>

        <b-tabs pills v-model="methodtab" ref="methodtabs">
            <b-tab class="card p-3" :title="$t('strings.frontend.checkout.method.wlt.title')"
                   data-payment-method="wlt" v-if="showPaymentMethod('wlt')">
                <label>
                    <input type="radio" id="wlt_type" name="wlt_type" value="PPE" checked="checked"/>
                    <label class="form-check-label" for="wlt_type">
                        PayPal
                    </label>
                </label>
            </b-tab>
            <b-tab class="card p-3" :title="$t('strings.frontend.checkout.method.sb.title')"
                   data-payment-method="sb" v-if="showPaymentMethod('sb')">
                <div class="form-group">
                    <div class="form-check form-check-inline" v-if="showPaymentMethod('sb', 'pnt')">
                        <input class="form-check-input" type="radio" value="PNT" name="onlinebanktransfertype"
                               v-model="onlinebanktransfertype" id="onlinebanktransfertype_pnt">
                        <label class="form-check-label" for="onlinebanktransfertype_pnt">
                            {{$t('strings.frontend.checkout.method.sb.type.pnt.title')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline" v-if="showPaymentMethod('sb', 'gpy')">
                        <input class="form-check-input" type="radio" value="GPY" name="onlinebanktransfertype"
                               v-model="onlinebanktransfertype" id="onlinebanktransfertype_gpy">
                        <label class="form-check-label" for="onlinebanktransfertype_gpy">
                            {{$t('strings.frontend.checkout.method.sb.type.gpy.title')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline" v-if="showPaymentMethod('sb', 'eps')">
                        <input class="form-check-input" type="radio" value="EPS" name="onlinebanktransfertype"
                               v-model="onlinebanktransfertype" id="onlinebanktransfertype_eps">
                        <label class="form-check-label" for="onlinebanktransfertype_eps">
                            {{$t('strings.frontend.checkout.method.sb.type.eps.title')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline" v-if="showPaymentMethod('sb', 'pff')">
                        <input class="form-check-input" type="radio" value="PFF" name="onlinebanktransfertype"
                               v-model="onlinebanktransfertype" id="onlinebanktransfertype_pff">
                        <label class="form-check-label" for="onlinebanktransfertype_pff">
                            {{$t('strings.frontend.checkout.method.sb.type.pff.title')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline" v-if="showPaymentMethod('sb', 'pfc')">
                        <input class="form-check-input" type="radio" value="PFC" name="onlinebanktransfertype"
                               v-model="onlinebanktransfertype" id="onlinebanktransfertype_pfc">
                        <label class="form-check-label" for="onlinebanktransfertype_pfc">
                            {{$t('strings.frontend.checkout.method.sb.type.pfc.title')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline" v-if="showPaymentMethod('sb', 'idl')">
                        <input class="form-check-input" type="radio" value="IDL" name="onlinebanktransfertype"
                               v-model="onlinebanktransfertype" id="onlinebanktransfertype_idl">
                        <label class="form-check-label" for="onlinebanktransfertype_idl">
                            {{$t('strings.frontend.checkout.method.sb.type.idl.title')}}
                        </label>
                    </div>
                </div>
                <div class="form-group" v-if="onlinebanktransfertype === 'EPS' || onlinebanktransfertype === 'IDL'">
                    <label class="form-check-label" for="bankgrouptype">
                        {{$t('strings.frontend.checkout.method.sb.bankgrouptype.title')}}
                    </label>
                    <select name="bankgrouptype" id="bankgrouptype" class="form-control">
                        <optgroup label="AT">
                            <option value="ARZ_OAB">Apothekerbank</option>
                            <option value="ARZ_BAF">Ärztebank</option>
                            <option value="EPS_AAB">Austrian Anadi Bank AG</option>
                            <option value="BA_AUS">Bank Austria</option>
                            <option value="ARZ_BCS">Bankhaus Carl Spängler & Co.AG</option>
                            <option value="EPS_SCHEL">Bankhaus Schelhammer & Schattera AG</option>
                            <option value="BAWAG_PSK">BAWAG P.S.K. AG</option>
                            <option value="EPS_BKS">BKS Bank AG</option>
                            <option value="EPS_BKB">Brüll Kallmus Bank AG</option>
                            <option value="EPS_VLB">BTV VIER LÄNDER BANK</option>
                            <option value="EPS_CBGG">Capital Bank Grawe Gruppe AG</option>
                            <option value="EPS_DB">Dolomitenbank</option>
                            <option value="BAWAG_ESY">Easybank AG</option>
                            <option value="SPARDAT_EBS">Erste Bank und Sparkassen</option>
                            <option value="AZR_HAA">Hypo Alpe-Adria-Bank International AG</option>
                            <option value="EPS_HBL">HYPO-BANK BURGENLAND Aktiengesellschaft</option>
                            <option value="AZR_VLH">Hypo Landesbank Vorarlberg</option>
                            <option value="EPS_NOEGB">HYPO NOE Gruppe Bank AG</option>
                            <option value="EPS_NOELB">HYPO NOE Landesbank AG</option>
                            <option value="HRAC_OOS">HYPO Oberösterreich,Salzburg,Steiermark</option>
                            <option value="ARZ_HTB">Hypo Tirol Bank AG</option>
                            <option value="ARZ_IMB">Immo-Bank</option>
                            <option value="EPS_MFB">Marchfelder Bank</option>
                            <option value="EPS_OBAG">Oberbank AG</option>
                            <option value="RAC_RAC">Raiffeisen Bankengruppe Österreich</option>
                            <option value="EPS_SCHOELLER">Schoellerbank AG</option>
                            <option value="EPS_SPDBW">Sparda Bank Wien</option>
                            <option value="EPS_SPDBA">SPARDA-BANK AUSTRIA</option>
                            <option value="ARZ_OVB">Volksbank Gruppe</option>
                            <option value="EPS_VKB">Volkskreditbank AG</option>
                            <option value="EPS_VRBB">VR-Bank Braunau</option>
                        </optgroup>
                        <optgroup label="NL">
                            <option value="ABN_AMRO_BANK">ABM Amro</option>
                            <option value="ASN_BANK">ASN Bank</option>
                            <option value="BUNQ_BANK">Bunq</option>
                            <option value="ING_BANK">ING Bank</option>
                            <option value="KNAB_BANK">Knab</option>
                            <option value="RABOBANK">Rabobank</option>
                            <option value="SNS_REGIO_BANK">Regio Bank</option>
                            <option value="MONEYOU">Moneyou</option>
                            <option value="SNS_BANK">SNS Bank</option>
                            <option value="TRIODOS_BANK">Triodos Bank</option>
                            <option value="VAN_LANSCHOT_BANKIER">van Lanschot</option>
                        </optgroup>
                        <optgroup label="TEST">
                            <option value="SPARDAT_EBS">Erste Bank und Sparkassen TEST</option>
                        </optgroup>
                    </select>
                </div>
                <div class="form-group">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="DE" id="sb_bankcountry_de"
                               v-model="bankcountry">
                        <label class="form-check-label" for="sb_bankcountry_de">
                            {{$t('strings.frontend.checkout.country.de')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="AT" id="sb_bankcountry_at"
                               v-model="bankcountry">
                        <label class="form-check-label" for="sb_bankcountry_at">
                            {{$t('strings.frontend.checkout.country.at')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="CH" id="sb_bankcountry_ch"
                               v-model="bankcountry">
                        <label class="form-check-label" for="sb_bankcountry_ch">
                            {{$t('strings.frontend.checkout.country.ch')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="NL" id="sb_bankcountry_nl"
                               v-model="bankcountry">
                        <label class="form-check-label" for="sb_bankcountry_nl">
                            {{$t('strings.frontend.checkout.country.nl')}}
                        </label>
                    </div>
                </div>
                <div class="form-group"
                     v-if="onlinebanktransfertype === 'PNT' || onlinebanktransfertype === 'GPY' || onlinebanktransfertype === 'PFF' || onlinebanktransfertype === 'PFC' || onlinebanktransfertype === 'P24' || onlinebanktransfertype === 'BCT'">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="sb_iban">{{$t('strings.frontend.checkout.labels.iban')}}:</label>
                        </div>
                        <input id="sb_iban" type="text" class="form-control" v-model.trim="iban"
                               v-mask="ibanMasks[bankcountry]" :placeholder="ibanMasks[bankcountry]"
                        />
                    </div>
                    <br/>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text"
                                   for="sb_bic">{{$t('strings.frontend.checkout.labels.bic')}}:</label>
                        </div>
                        <input id="sb_bic" type="text" class="form-control" v-model.trim="bic"/>
                    </div>
                </div>
            </b-tab>
            <b-tab class="card p-3" :title="$t('strings.frontend.checkout.method.vor.title')"
                   data-payment-method="vor" v-if="showPaymentMethod('vor')">
                <font-awesome-icon id="vor" :icon="['fas', 'money-check']" size="5x"></font-awesome-icon>
            </b-tab>
            <b-tab class="card p-3" :title="$t('strings.frontend.checkout.method.elv.title')"
                   data-payment-method="elv" v-if="showPaymentMethod('elv')">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label for="accountowner" class="input-group-text">{{$t('strings.frontend.checkout.labels.accountOwner')}}:</label>
                        </div>
                        <input id="accountowner" name="accountowner" type="text" class="form-control"
                               :placeholder="$t('strings.frontend.checkout.placeholders.accountOwner')"
                               v-model.trim="accountowner"/>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="DE" id="elv_bankcountry_de"
                               v-model="bankcountry">
                        <label class="form-check-label" for="elv_bankcountry_de">
                            {{$t('strings.frontend.checkout.country.de')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="AT" id="elv_bankcountry_at"
                               v-model="bankcountry">
                        <label class="form-check-label" for="elv_bankcountry_at">
                            {{$t('strings.frontend.checkout.country.at')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="CH" id="elv_bankcountry_ch"
                               v-model="bankcountry">
                        <label class="form-check-label" for="elv_bankcountry_ch">
                            {{$t('strings.frontend.checkout.country.ch')}}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" value="NL" id="elv_bankcountry_nl"
                               v-model="bankcountry">
                        <label class="form-check-label" for="elv_bankcountry_nl">
                            {{$t('strings.frontend.checkout.country.nl')}}
                        </label>
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="elv_iban">{{$t('strings.frontend.checkout.labels.iban')}}:</label>
                        </div>
                        <input id="elv_iban" type="text" class="form-control" v-model.trim="iban"
                               v-mask="ibanMasks[bankcountry]" :placeholder="ibanMasks[bankcountry]"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="elv_bic">{{$t('strings.frontend.checkout.labels.bic')}}:</label>
                        </div>
                        <input id="elv_bic" type="text" class="form-control" v-model.trim="bic"/>
                    </div>
                </div>
            </b-tab>
            <b-tab class="card p-3" :title="$t('strings.frontend.checkout.method.cc.title')"
                   data-payment-method="cc" v-if="showPaymentMethod('cc')">
                <div class="form-row">
                    <div class="form-group col-md-4 input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="cardtype">{{$t('strings.frontend.checkout.method.cc.cardtype')}}</label>
                        </div>
                        <span class="inputIframe form-control p-0 border-0" id="cardtype"></span>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-8 input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="cardpan">{{$t('strings.frontend.checkout.method.cc.cardpan')}}</label>
                        </div>
                        <span class="inputIframe form-control p-0 border-0" id="cardpan"></span>
                    </div>

                    <div class="form-group col-md-4 input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="cardcvc2">{{$t('strings.frontend.checkout.method.cc.cvc')}}</label>
                        </div>
                        <span class="inputIframe form-control p-0 border-0" id="cardcvc2"></span>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6 input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="cardexpiremonth">{{$t('strings.frontend.checkout.method.cc.expire.month')}}</label>
                        </div>
                        <span id="cardexpiremonth" class="form-control p-0 border-0"></span>
                    </div>
                    <div class="form-group col-md-6 input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="cardexpireyear">{{$t('strings.frontend.checkout.method.cc.expire.year')}}</label>
                        </div>
                        <span id="cardexpireyear" class="form-control p-0 border-0"></span>
                    </div>
                </div>

                <div id="errorOutput"></div>
            </b-tab>
            <b-tab class="card p-3" :title="$t('strings.frontend.checkout.method.rec.title')"
                   data-payment-method="rec" v-if="showPaymentMethod('rec')">
                <div class="form-group">
                    <label for="birthday">{{$t('strings.frontend.checkout.labels.birthday')}}:</label>
                    <input id="birthday" type="date" class="form-control" v-model.trim="birthday"/>
                </div>
                <div class="form-group">
                    <label for="invoice_date">{{$t('strings.frontend.checkout.labels.invoiceDate')}}:</label>
                    <input id="invoice_date" name="invoice_date" type="date" class="form-control"
                           :placeholder="$t('strings.frontend.checkout.placeholders.invoiceDate')"/>
                </div>
            </b-tab>
        </b-tabs>
        <div ref="payoneError">{{errorMessage}}</div>
    </fieldset>
</template>

<script>
    export default {
        props: [
            'config',
            'values',
            'paymentMethod',
            'user'
        ],
        data: function () {
            let propValues = this.values;

            if (!propValues) {
                propValues = {
                    firstname: '',
                    lastname: ''
                }
            }

            return {
                payoneIframes: Object,
                localPaymentMethod: this.paymentMethod,
                methodtab: -1,
                firstname: propValues.firstname ?? '',
                lastname: propValues.lastname ?? '',
                fullname: '',
                accountowner: '',
                onlinebanktransfertype: '',
                iban: '',
                bic: '',
                birthday: '',
                bankcountry: 'DE',
                cardtype: '',
                cardexpiredate: '',
                pseudocardpan: '',
                truncatedcardpan: '',
                errorMessage: '',
                ibanMasks: {
                    AT: "AT## #### #### #### ####",
                    DE: "DE## #### #### #### #### ##",
                    NL: "NL## #### #### #### ##",
                    CH: "CH## #### #### #### #### #"
                }
            }
        },
        watch: {
            methodtab: {
                immediate: true,
                handler: function (newtab, oldtab) {
                    let newMethod = null;
                    let oldMethod = this.localPaymentMethod;

                    let methodtabsControl = this.$refs.methodtabs;

                    if (methodtabsControl) {
                        let tab = methodtabsControl.tabs[newtab];

                        if (tab) {
                            newMethod = tab.$attrs['data-payment-method'];
                        }
                    }

                    if (newMethod && newMethod !== oldMethod) {
                        this.localPaymentMethod = newMethod;
                        this.$emit('payment-method-changed', newMethod, oldMethod)
                    }
                }
            },
        },
        mounted: function () {
            const vueComponent = this;
            let supportedCardtypes = ["A", "V", "M"];

            if(this.user){
               this.firstname = this.user.first_name;
               this.lastname = this.user.last_name;
            }

            let config = {
                fields: {
                    cardtype: {
                        selector: "cardtype",                // put name of your div-container here
                        cardtypes: supportedCardtypes          // define possible cardtypes in PAYONE iFrame
                    },
                    cardpan: {
                        selector: "cardpan",                 // put name of your div-container here
                        type: "text",                        // text (default), password, tel
                        style: ""
                    },
                    cardcvc2: {
                        selector: "cardcvc2",                // put name of your div-container here
                        type: "password",                    // select(default), text, password, tel
                        size: "4",
                        maxlength: "4",                      // set max. length for CVC input; empty values possible
                        length: {"A": 4, "V": 3, "M": 3, "J": 0} // set required CVC length per cardtype
                        // if set exact length required; 0=CVC input disabled
                    },
                    cardexpiremonth: {
                        selector: "cardexpiremonth",         // put name of your div-container here
                        type: "select",                      // select(default), text, password, tel
                        size: "2",
                        maxlength: "2",
                    },
                    cardexpireyear: {
                        selector: "cardexpireyear",          // put name of your div-container here
                        type: "select",                      // select(default), text, password, tel
                    }
                },
                defaultStyle: {
                    input: "width:100%;height:100%;padding:3px",
                    select: "width:100%;height:100%",
                    iframe: {
                        height: "100%",
                        width: "100%"
                    }
                },
                error: "errorOutput",                        // area to display error-messages (optional)
                language: Payone.ClientApi.Language.de       // Language to display error-messages
                                                             // (default: Payone.ClientApi.Language.en)
            };

            let paymentMethod = this.localPaymentMethod;
            //let payoneConfig = paymentMethod === 'cc' ? vueComponent.config.creditcardcheck : vueComponent.config.bankaccountcheck;

            vueComponent.$log.info(paymentMethod);

            vueComponent.payoneIframes = new Payone.ClientApi.HostedIFrames(config, vueComponent.config.creditcardcheck);
        },
        methods: {
            checkAndStore: function () {
                const vueComponent = this;

                let paymentMethod = this.localPaymentMethod;
                if (!['cc'].includes(paymentMethod)) {
                    return Promise.resolve(true);
                }

                if (!this.payoneIframes.isComplete()) {
                    return Promise.reject('Not complete');
                }

                let functionName = 'processPayoneResponse_' + paymentMethod + '_' + Date.now();

                return new Promise(function (resolve, reject) {
                    window[functionName] = function (response) {
                        vueComponent.$log.debug(response);

                        if (response['status'] === 'VALID') {
                            vueComponent.cardexpiredate = response['cardexpiredate'];
                            vueComponent.cardtype = response['cardtype'];
                            vueComponent.pseudocardpan = response['pseudocardpan'];
                            vueComponent.truncatedcardpan = response['truncatedcardpan'];

                            resolve(true);
                        } else {
                            vueComponent.errorMessage = response.customermessage;
                            reject(response.customermessage);
                        }
                    };

                    vueComponent.errorMessage = '';

                    vueComponent.payoneIframes.creditCardCheck(functionName);
                }).finally(() => {
                    delete window[functionName];
                });
            }
            ,
            showPaymentMethod: function (method, subMethod) {
                if (!this.config || !this.config.methods) {
                    this.$log.debug("No config", method, subMethod);
                    return false;
                }

                let methods = this.config.methods;
                if (!(methods instanceof Object)) {
                    this.$log.debug("No config object", method, subMethod);
                    return false;
                }

                if (!(methods.hasOwnProperty(method) && methods[method.toLowerCase()])) {
                    this.$log.debug("No config property", method, subMethod);
                    return false
                }

                let methodConfig = methods[method.toLowerCase()];

                if (!methodConfig) {
                    this.$log.debug("No method config", method, subMethod);
                    return false;
                }

                if ('boolean' === typeof methodConfig) {
                    return !!methodConfig;
                }

                if (!(methodConfig instanceof Object)) {
                    this.$log.debug("No method config object", method, subMethod);
                    return false;
                }

                if (!subMethod) {
                    return !!methodConfig;
                }

                let subMethodLower = subMethod.toLowerCase();
                if (!methodConfig.hasOwnProperty(subMethodLower)) {
                    return false;
                }

                return !!(methodConfig[subMethodLower]);
            }
        }
    }
</script>
